import React, {useEffect, useState} from 'react';
import {ImageBackground, Text, TouchableOpacity, useWindowDimensions, View} from 'react-native';
import {connect} from 'react-redux';
import {useNavigation} from '@react-navigation/native';

import {LastUpdateDate} from '@components/atoms';
import imageProfile from '@images/profile-header2.png';
import Menu from '@images/icons/menu.svg';
import {styles} from './styles';
import WalletIcon from "@images/icons/wallet.svg";

const Header = ({
                    displayName,
                    subtitle,
                    detail,
                    welcome,
                    lastUpdateDate,
                    style,
                    icon,
                }) => {
    const navigation = useNavigation();

    const {width} = useWindowDimensions();

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const isSmall = width < 1070;
        setIsMobile(isSmall);
    }, [width]);

    return (
        <ImageBackground
            source={imageProfile}
            style={[
                styles.image,
                style,
                {
                    //flexDirection: 'row',
                    alignItems: 'flex-start',
                },
            ]}
        >
            {/*width < 1070 && (
                <TouchableOpacity style={{paddingBottom: 5}} onPress={() => navigation.openDrawer()}>
                    <Menu/>
                </TouchableOpacity>
            )*/}
            <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                // alignItems: 'center',
                width: '100%',
            }}>
                <View style={{
                    flexDirection: 'row',
                    // alignItems: 'stretch',
                    justifyContent: 'flex-start',
                    // alignItems: 'center',
                }}>

                    {!!icon && (
                        <View style={{paddingRight: 15, alignItems: 'center', justifyContent: 'center'}}>
                            <WalletIcon/>
                        </View>
                    )}
                    {welcome && (
                        <Text style={styles.title}>Добро пожаловать в приложение</Text>
                    )}
                    {icon && subtitle && detail && (
                        <View>
                            <Text style={[styles.subtitle]}>{subtitle}</Text>
                            <Text style={[styles.detail]}>{detail}</Text>
                        </View>
                    )}
                </View>
                {!(isMobile) && (
                    <LastUpdateDate style={[styles.title, styles.details]}/>
                )}
            </View>

        </ImageBackground>
    );
};

const mapStateToProps = ({user}) => ({
    user,
    isLogin: !!user.id,
    displayName: user.displayName,
});

export const HeaderPayment = connect(mapStateToProps)(Header);
